export default "__VITE_ASSET__DjSsOJG0__"